import React from "react";
import ReactDOM from "react-dom/client";
import "./app/style/index.css";
import App from "./app/components/App";
import reportWebVitals from "./reportWebVitals";
import Poncho from "@cpmis/poncho";
import "./app/style/_variables.css";
import { BrowserRouter } from "react-router-dom";
import gwFetchInstance from "./api/apiHelper";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

const root = ReactDOM.createRoot(document.getElementById("root"));

const fetchClient = gwFetchInstance;

const ponchoSettings = {
  fetchClient,
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const getBaseName = () => {
  if(window.location.host.match("ucapps")){
      return process.env.REACT_APP_ROUTE_BASE_NAME_WITHOUT_UCAPPS;
  }
  return process.env.REACT_APP_ROUTE_BASE_NAME;
}

root.render(
  <Poncho {...ponchoSettings}>
    <BrowserRouter basename={getBaseName()}>
      <QueryClientProvider client={queryClient}>
        <App />
        {/*todo: add a condition before deployment on the devtools*/}
        <ReactQueryDevtools initialIsOpen={false}></ReactQueryDevtools>
      </QueryClientProvider>
    </BrowserRouter>
  </Poncho>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
